import { render, staticRenderFns } from "./FaultsTwinWidget.vue?vue&type=template&id=f8ae4e2a&scoped=true"
import script from "./FaultsTwinWidget.vue?vue&type=script&lang=js"
export * from "./FaultsTwinWidget.vue?vue&type=script&lang=js"
import style0 from "./FaultsTwinWidget.vue?vue&type=style&index=0&id=f8ae4e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ae4e2a",
  null
  
)

export default component.exports